import { FIND_ASSIGNABLE_ADDON_ROUTINES } from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoutineColumns } from '../../new-routines/components/useRoutineColumns';

export type AddonRoutinesAssignListProps = {
  workspaceId: string;
  addonId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const AddonRoutinesAssignList = ({
  workspaceId,
  addonId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: AddonRoutinesAssignListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (assignments && workspaceId) {
      return { keyword, addonId, assignments, workspaceId };
    }
    return undefined;
  });
  const columns = useRoutineColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({ keyword, addonId, assignments, workspaceId });
  }, [keyword, addonId, workspaceId]);

  if (!filter) return null;

  return (
    <InfiniteDataGrid
      modelName="routine"
      hideResultsLabel={true}
      query={FIND_ASSIGNABLE_ADDON_ROUTINES}
      filter={filter}
      pageSize={100}
      columns={columns}
      listMaxHeight={maxHeight as number}
      containerStyle={{ height: maxHeight }}
      paddingBottom={0}
      textEmpty={t('routines.textEmpty')}
      dataPrefix="addon.findAssignableRoutinesForAddon"
      updateRowsSelected={(rows) => updateAssignments(rows.map(row => row.id))}
      isRowSelected={(row) => assignments.includes(row.id)}
      enableScrollRefresh={true}
      showScrollIndicator={true}
    />
  );
};
